// ═══ 말소 셸 (B3 리뷰 §3.9) — malsoActiveFor 사용자의 /main/* 를 대체한다 (SimpleShell.js 축소 복제) ═══
// Dashboard 래퍼가 검차 판정보다 먼저 본다. 차량관리 크롬 변형 없음 — 모든 /main/* 가 이 셸(routes catch-all → /main/m/home).
// ≥1024: 상단 앱바(로고 · 홈·말소·정산 탭 · 회사명 메뉴 MalsoWhoMenu — '더보기' 를 흡수) / 769~1023: 앱바(로고 · 4탭 · 언어 · 회사)
// ≤768: 얇은 상단 바 + 하단 고정 탭(홈 · 말소 · 정산 · 더보기). AI도우미 없음 · 소켓 relay 없음(화면이 직접 구독, 리뷰 P6·P7).
// RTL 은 **이 컨테이너 스코프** — I18nProvider 의 전역 <html dir> 은 경매 바이어 도메인 전용.
// props: { user, onLogout }
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useT, useLocale } from '../../i18n/I18nProvider';
import { useIsMobile } from '../../utils/useMobile';
import { useIsDesktop } from '../simple/useDesktop';
import { putLocale } from './api';
import MalsoRoutes, { MALSO_TABS, tabIdOf } from './routes';
import BugReportButton from '../../components/BugReportButton';
import BottomTabs from '../simple/parts/BottomTabs';
import SimpleAppBar from '../simple/parts/SimpleAppBar';
import MalsoWhoMenu from './parts/MalsoWhoMenu';
import '../simple/simple.css';

function MalsoShell(props) {
  var t = useT();
  var loc = useLocale();
  var isMobile = useIsMobile();
  var isDesktop = useIsDesktop();
  var navigate = useNavigate();
  var location = useLocation();

  // 마운트 시 + 언어 변경 시 서버에 저장 — 실패는 putLocale 내부에서 무시. 메뉴(MalsoWhoMenu)는 호출하지 않는다.
  useEffect(function () { putLocale(loc.locale); }, [loc.locale]);

  var activeTab = tabIdOf(location.pathname);
  // 데스크톱은 '더보기' 를 회사명 메뉴로 옮긴다 — /main/m/more 라우트는 직접 진입용으로 남는다.
  var tabs = MALSO_TABS.filter(function (tab) {
    return !(isDesktop && tab.id === 'more');
  }).map(function (tab) {
    return { id: tab.id, label: t(tab.labelKey), onClick: function () { navigate(tab.to); } };
  });

  // 토스트 — 화면(HEIC 거부·공유 링크 복사 등)과 메뉴가 같은 showToast 를 쓴다.
  var _toast = useState(null); var toast = _toast[0]; var setToast = _toast[1];
  var showToast = function (msg, type) { setToast({ msg: msg, type: type }); setTimeout(function () { setToast(null); }, 2000); };

  return (<><div className="simple-shell" dir={loc.locale === 'ar' ? 'rtl' : 'ltr'} lang={loc.locale}>
    <SimpleAppBar user={props.user} onLogout={props.onLogout}
      who={<MalsoWhoMenu user={props.user} onLogout={props.onLogout} showToast={showToast} />}
      tabs={tabs} activeTab={activeTab} isMobile={isMobile} isDesktop={isDesktop} />

    <main className="ss-page">
      <div className="ss-inner">
        <MalsoRoutes user={props.user} onLogout={props.onLogout} showToast={showToast} />
      </div>
    </main>

    {isMobile ? <BottomTabs items={tabs} activeId={activeTab} /> : null}
  </div>
  <BugReportButton user={props.user} showToast={showToast} />
  {toast ? <div className={'ss-toast' + (toast.type === 'err' ? ' ss-toast-err' : '')} role="status">{toast.msg}</div> : null}</>);
}

export default MalsoShell;
